import { ApiService } from "@selas/api-communication";

import { addAuthentication } from "../authentication";
import handleError from "../errorHandling";
import endpoints from "./endpoints";

ApiService.init(endpoints, addAuthentication, handleError);
